import React, { useEffect, useRef, useState, ReactNode  } from 'react';
import './pageStyles/LandingPage.css';
import { AccountInfo } from '@azure/msal-common';
import { useMsal } from '@azure/msal-react';
import useAnalyticsEventTracker from '../components/_common/useAnalyticsEventTracker';
import DonateSection from '../components/landingPage/DonateSection';
import MainHero from '../components/landingPage/MainHero';
import Header from '../components/landingPage/LandingHeader';
import {AboutUs} from './AboutUs';
import '../App.css';
import Canvas from '../components/landingPage/Canvas';
import Product from '../components/landingPage/Product';
import LazyShow from '../components/landingPage/LazyShow';
import MainHeroImage from '../components/landingPage/MainHeroImage';
import Features from '../components/landingPage/Features';
import { useLocation } from 'react-router-dom';
import { Footer } from '../components/landingPage/Footer';
import  PricingTable  from "../components/profilePage/PricingTable"
import FeatureFlags from '../components/_common/FeatureFlags';
import UserAPI from '../components/_api/UserAPI';
import { set } from 'react-ga';
export function LandingPageFin() {
  const gaEventTracker = useAnalyticsEventTracker('landingPage');
  gaEventTracker('enterNgLanding');
  const [shouldRender, setShouldRender] = useState(false);
  const [premiumTrackingFlag, setPremiumTrackingFlag] = useState(true);

  const location = useLocation();

  useEffect(() => {
      const hasRefreshed = sessionStorage.getItem('hasRefreshed');
      if (location.pathname === '/' && (!hasRefreshed || hasRefreshed === 'false')) {
          sessionStorage.setItem('hasRefreshed', 'true');
          window.location.reload();
      } else {
          setShouldRender(true); // Only render the children after the refresh check
      }
  }, [location]);
  const { instance } = useMsal();
  const [activeAccount] = useState<AccountInfo | null>(instance.getActiveAccount());
  let [userHasPremium, setUserHasPremium] = useState<boolean | null>(null);
  const userAPI = useRef(new UserAPI()).current;

  useEffect(() => {
    if (!activeAccount?.localAccountId) { return; }
    userAPI.getPremiumStatus(activeAccount.localAccountId).then((result) => {
      setUserHasPremium(result);
    });
  }, [activeAccount?.localAccountId, userAPI]);
  if (!shouldRender) {
    return null; // Prevent initial render until refresh logic is handled
  } else {
    return (
      <div >
        <div className={`bg-background grid gap-y-16 overflow-hidden`}>
          <div className={`relative bg-background`}>
            <div className="max-w-7xl mx-auto">
              <div
                className={`relative z-10 pb-8 bg-background sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32`}
              >
                <Header />
                <MainHero />
              </div>
            </div>
            <MainHeroImage />
          </div>
          <Canvas />
          <LazyShow>
            <>
              <Product />
              <Canvas />
            </>
          </LazyShow>
          <LazyShow>
            <>
              <Features />
              <Canvas />
            </>
          </LazyShow>
          {premiumTrackingFlag ? <div className="container max-w-5xl mx-auto m-8" ><PricingTable userHasPremium={userHasPremium}></PricingTable> </div>: null}
          
          <LazyShow>
              <AboutUs />
          </LazyShow>

        </div>
        <Footer />
      </div>
    );
  }
}
